<template>
	<el-dialog
		title="申请购买额外书单"
		:visible.sync="dialogVisible"
		width="640px"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		append-to-body
		@close="handleClose"
	>
		<!-- ===== 图书信息 ===== -->
		<div class="form-section-title">图书信息</div>

		<div class="book-list">
			<div class="book-list-header">
				<span class="col-name">书名</span>
				<span class="col-qty">数量</span>
				<span class="col-action"></span>
			</div>

			<div class="book-list-body">
				<div
					v-for="(item, idx) in bookList"
					:key="idx"
					class="book-list-row"
				>
					<div class="col-name">
						<el-input
							v-model="item.spuName"
							placeholder="请输入书名"
							size="small"
							clearable
						/>
					</div>
					<div class="col-qty">
						<el-input-number
							v-model="item.buyNum"
							:min="1"
							:max="9999"
							size="small"
							controls-position="right"
						/>
					</div>
					<div class="col-action">
						<i
							class="el-icon-remove-outline"
							:class="{ 'disabled': bookList.length <= 1 }"
							@click="removeBook(idx)"
						></i>
					</div>
				</div>
			</div>

			<div class="book-list-add">
				<el-button type="text" icon="el-icon-plus" @click="addBook">添加图书</el-button>
			</div>
		</div>

		<!-- ===== 上传附件 ===== -->
<!--		<div class="form-section-title">上传附件</div>-->

<!--		<div class="upload-section">-->
<!--			<upload-file-list-->
<!--				ref="uploadRef"-->
<!--				:accept="uploadAccept"-->
<!--				:max-size="200"-->
<!--				:limit="10"-->
<!--			/>-->
<!--			<div class="upload-tip">支持 PDF、Excel、Word（doc/docx）、图片，单个文件不超过 200MB</div>-->
<!--		</div>-->

		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="handleClose">取消</el-button>
			<el-button size="small" type="primary" :loading="submitting" @click="handleConfirm">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
import UploadFileList from '@/components/UploadFileList/index.vue';
import TMessage from '@/utils/TMessage';

export default {
	name: 'DialogApplyExtra',
	components: { UploadFileList },
	data() {
		return {
			uploadAccept: '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.jpeg,.png,.gif,.bmp',
			dialogVisible: false,
			submitting: false,
			bookList: [
				{ spuName: '', buyNum: 1 }
			]
		};
	},
	methods: {
		open() {
			this.bookList = [{ spuName: '', buyNum: 1 }];
			this.dialogVisible = true;
		},

		addBook() {
			this.bookList.push({ spuName: '', buyNum: 1 });
		},

		removeBook(idx) {
			if (this.bookList.length <= 1) return;
			this.bookList.splice(idx, 1);
		},

		handleClose() {
			this.dialogVisible = false;
			this.submitting = false;
			this.$refs.uploadRef && this.$refs.uploadRef.clearFileList();
		},

		handleConfirm() {
			// 过滤空书名
			const validBooks = this.bookList.filter(item => item.spuName && item.spuName.trim());
			if (validBooks.length === 0) {
				TMessage.warning('请至少填写一个书名');
				return;
			}

			this.submitting = true;
			const params = {
				goodList: validBooks
			};

			this.$store.dispatch('Cart/addCart', params).then(() => {
				TMessage.success('商品已添加至购物车');
				this.dialogVisible = false;
				this.submitting = false;
			});

			
			return
			const attachments = this.$refs.uploadRef ? this.$refs.uploadRef.getFileList() : [];

			// 构造自定义购物车数据，标记来源
			const customItems = validBooks.map((item, idx) => ({
				id: 'custom_' + Date.now() + '_' + idx,
				prdSpuName: item.spuName.trim(),
				prdSkuName: '',
				buyNum: item.buyNum,
				curBuyNum: item.buyNum,
				curPrice: 0,
				salePrice: 0,
				fixedPrice: 0,
				vipPrice: 0,
				defaultPrice: 0,
				isDigit: 0,
				source: 'custom',       // 自定义添加标识
				checked: true,
				isSelected: true,
				attachments: attachments
			}));

			// 通过 store dispatch 添加到购物车或 emit 给父组件处理
			this.$emit('confirm', customItems);
			TMessage.success('已添加至购物车');
			this.dialogVisible = false;
			this.submitting = false;
		}
	}
};
</script>

<style lang="less" scoped>
.form-section-title {
	display: flex;
	align-items: center;
	font-size: 15px;
	font-weight: 600;
	color: #0f172a;
	margin: 0 0 14px;
	padding-bottom: 10px;
	border-bottom: 1px dashed #e2e8f0;
}

// 图书列表
.book-list {
	border: 1px solid #e2e8f0;
	border-radius: 10px;
	overflow: hidden;
	margin-bottom: 24px;
}

.book-list-header {
	display: flex;
	align-items: center;
	padding: 10px 14px;
	background: #f8fafc;
	border-bottom: 1px solid #e2e8f0;
	font-size: 12px;
	color: #94a3b8;
	font-weight: 500;
}

.book-list-body {
	padding: 8px 14px;
}

.book-list-row {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 0;

	& + & {
		border-bottom: 1px solid #f1f5f9;
	}
}

.col-name {
	flex: 1;
	min-width: 0;
}

.col-qty {
	width: 130px;
	flex-shrink: 0;
}

.col-action {
	width: 32px;
	flex-shrink: 0;
	text-align: center;

	i {
		font-size: 18px;
		color: #ef4444;
		cursor: pointer;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.7;
		}

		&.disabled {
			color: #cbd5e1;
			cursor: not-allowed;

			&:hover {
				opacity: 1;
			}
		}
	}
}

.book-list-add {
	padding: 10px 14px;
	border-bottom: 1px solid #f1f5f9;

	.el-button {
		font-size: 13px;
		color: #155dfc;

		i {
			margin-right: 4px;
		}
	}
}

// 上传
.upload-section {
	margin-bottom: 8px;
}

.upload-tip {
	margin-top: 6px;
	font-size: 12px;
	color: #94a3b8;
	line-height: 1.5;
}

.dialog-footer {
	text-align: right;
}

/deep/ .el-dialog__header {
	border-bottom: 1px solid #e2e8f0;
	padding: 20px 24px 16px;
}

/deep/ .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #0f172a;
}

/deep/ .el-dialog__body {
	padding: 20px 24px 8px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e2e8f0;
	padding: 14px 24px;
}
</style>
